import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-associar-epi',
  templateUrl: './associar-epi.component.html',
  styleUrls: ['./associar-epi.component.scss'],
})
export class AssociarEpiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
